import { render } from "./AskQuestionExamples.vue?vue&type=template&id=3a5a8a7a&scoped=true"
import script from "./AskQuestionExamples.vue?vue&type=script&lang=js"
export * from "./AskQuestionExamples.vue?vue&type=script&lang=js"

import "./AskQuestionExamples.vue?vue&type=style&index=0&id=3a5a8a7a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a5a8a7a"]])

export default __exports__